import Reveal from 'stimulus-reveal-controller'

// Borrows Reveal controller from Stimulus, but reveals the item linked
// to the triggering toggle and hides all others.
export default class extends Reveal {
  show(event) {
    const target = event.currentTarget.getAttribute('data-reveal-one-hide-rest-target')

    this.showOnly(target)
  }

  showOnly (visibleItem) {
    this.itemTargets.forEach((item) => {
      const current = item.getAttribute('data-reveal-one-hide-rest-value')
      item.classList.toggle(this.hiddenClass, current !== visibleItem)
    })
  }
}
